module.exports = __webpack_public_path__ + "08_long_brown.6fa080c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/08_long_brown.png
// module id = EFnS
// module chunks = 0